<template>
  <popper trigger="hover" :options="{placement: 'left'}">
    <div class="popper">
      <table>
          <tbody>
            <tr v-for="(g, gIndex) in liveListing.priceCalcLog" :key="gIndex" style="text-align:left;">
                <td><b>{{g[0]}}</b></td>
                <td>{{g[1]}}</td>
            </tr>
          </tbody>


      </table>
    </div>
    <p href="#" slot="reference" class="top mb-0">{{ Number(liveListing.sellingPriceMin).toFixed(2) + ' ' + liveListing.currencySymbol }}</p>
</popper>
</template>

<script>

export default {
  props : {
    liveListing: {
      type : Object,
      requiered: true,
    }
  }
}
</script>
